import * as locales from 'date-fns/locale';

type LocaleKey = keyof typeof locales;

export const getLocale = (localeCode: string) => {
  const [languageCode, regionCode] = localeCode.split('_');

  if (languageCode === 'no') {
    return locales.nb;
  }

  if (locales[languageCode as LocaleKey]) {
    return locales[languageCode as LocaleKey];
  }

  const localeKey = `${languageCode}${regionCode}`;
  return locales[localeKey as LocaleKey] ?? locales.enGB;
};
